import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SubscriptionDetails from "./SubscriptionDetails";
import WebisteDetails from "./WebsiteDetails";
import apiInstance from "../../../../apiInstance";
import SubscriptionPayments from "./SubscriptionPayments";

const DetailsPage = () => {
    
    const { subId } = useParams();
    const [subscriptionDetails, setSubscriptionDetails] = useState({});
    const [site, setSite] = useState({});
    const [payments, setPayments] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSubDetails = async () => {
            apiInstance
                .get(`/dashboard/subscription/${subId}`)
                .then((response) => {
                    setSubscriptionDetails(response.data.subscription?.subscriptionDetails || {});                   
                    setSite(response.data.subscription?.subscriptionDetails?.site || {});                  
                    setPayments(response.data.subscription?.payments || []);                                        
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load subscription details.");
                });
        }
        fetchSubDetails();
    }, [subId])

    return (
        <>
            <div className="mjs-dash-header">
                <button className="mjs-btn" onClick={() => navigate("/billing")}>Back</button>
            </div>
            <SubscriptionDetails
                subscriptionDetails={subscriptionDetails}
            />
            <WebisteDetails
                site={site}
                subscriptionDetails={subscriptionDetails}
            />
            <SubscriptionPayments 
                subscriptionDetails={subscriptionDetails}
                payments={payments}
            />
            <div className="mjs-error">{error}</div>
        </>
    );
};

export default DetailsPage;
